import { ProjectInterconnectionTypesShort } from '~/constants';
import { display } from '~/utils/displayValues/common';
import { Project } from '~/types/project';

export default function interconnectionType(project: Project) {
  const interconnectionType = project?.interconnectionType as 'BEHIND_METER' | 'FRONT_OF_METER';
  return display(ProjectInterconnectionTypesShort[interconnectionType]);
}
